import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import CanBusLoadCalculator from '../components/tools/CanBusLoadCalculator';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'CAN Bus Load Calculator | AUTOXIUM';
const PAGE_DESCRIPTION = 'Calculate CAN bus load % live from a table of periodic messages. Free online CAN bus utilization calculator with bit-rate presets, worst-case stuffing, and per-message bandwidth breakdown.';

const CanBusLoadCalculatorPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="can-bus-load-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities / Communication"
        title="CAN Bus Load Calculator"
        description="Build a table of periodic CAN messages and see the resulting bus load % update live, with per-message bandwidth breakdown and a color-coded headroom summary."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="can-bus-load-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <CanBusLoadCalculator />
          <ToolGuideCta guidePath="/tools/can-bus-load-calculator/guide" toolName="CAN Bus Load Calculator" />
        </div>
      </section>
    </div>
  );
};

export default CanBusLoadCalculatorPage;
